
<div mat-dialog-title>Schwab&reg; Asset Classes</div>
<mat-dialog-content>
  <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
  <div class="block">Schwab Asset Classes are organized into Levels 1-4, ranging from broad to specific. Securities are automatically assigned to asset classes, which may be subject to change.</div>
  <div class="block">
    <span style="margin-right: 10px"><a (click)="expandAll()">Expand all</a></span>
    <span style="margin-right: 10px; padding-left: 10px; border-left: 1px solid #CCC"><a (click)="collapseAll()">Collapse all</a></span>
  </div>
  @if (!isUiTest) {
    <div class="block"><irb-inventory-grid
      [style.width] = "'100%'"
      [style.height] = "'280px'"
      [showSideBar] = "false"
      [gridOptions] = "gridOptions"
      [frameworkComponents] = 'frameworkComponents'
      (gridReady) = "onGridReady($event)"
    [rowData] = "data"></irb-inventory-grid></div>
  }
</mat-dialog-content>
